/**
 * DocViewSchema for Shopee Listing DocType
 *
 * Read-only detail page for marketplace-synced Shopee product data.
 * Single-tab layout with iPad Settings card sections.
 * All sections use shared marketplace widgets with "Shopee" channel config.
 */

import type { DocViewSchema } from "./types";

export const shopeeListingDocViewSchema: DocViewSchema = {
  doctype: "Shopee Listing",
  views: {
    experience: {
      style: "shopify",
      sections: [
        { id: "sync-status", label: "Sync Status", widgetId: "MarketplaceSyncStatusWidget", description: "Shopee" },
        { id: "images", label: "Product Images", widgetId: "MarketplaceImagesWidget", description: "Shopee" },
        { id: "product-info", label: "Product Info", widgetId: "MarketplaceProductInfoWidget", description: "Shopee" },
        { id: "pricing", label: "Pricing", widgetId: "MarketplacePricingWidget", description: "Shopee" },
        { id: "package", label: "Package & Logistics", widgetId: "MarketplacePackageWidget", description: "Shopee" },
        { id: "inventory", label: "Inventory", widgetId: "MarketplaceInventoryWidget", description: "Shopee" },
        { id: "linked-item", label: "Linked Item", widgetId: "MarketplaceLinkedItemWidget", description: "Shopee" },
        { id: "description", label: "Description", widgetId: "MarketplaceDescriptionWidget", description: "Shopee" },
      ],
      tabs: [
        {
          id: "details",
          label: "Details",
          sectionIds: ["sync-status", "images", "product-info", "pricing", "package", "inventory", "linked-item", "description"],
        },
      ],
    },
  },
};
